import { Box, Button, HStack } from '@chakra-ui/react';
import { useState } from 'react';

import {
  CustomDrawer,
  CustomDrawerFooter,
  CustomDrawerHeader,
  CustomModal,
  PillButton,
} from '../../../../../components/custom';
import { useAppDispatch } from '../../../../../store/hooks';
import { resetTransactionApprove } from '../../../../../store/slices/transactionMandate/approveTransaction';
import { resetTransactionDecline } from '../../../../../store/slices/transactionMandate/declineTransaction';
import { IPendingTransactionForApproval } from '../../../../../types/pendingTransaction';
import ApproveTransactionMandate from './ApproveTransactionMandate';
import DeclineTransactionMandate from './DeclineTransactionMandate';
import TransactionDetails from './TransactionDetails';

interface AwaitingApprovalTableActionsProps {
  transaction: IPendingTransactionForApproval;
}

export default function AwaitingApprovalTableActions({
  transaction,
}: AwaitingApprovalTableActionsProps) {
  const dispatch = useAppDispatch();

  const [drawerViewStates, setDrawerViewStates] = useState<{
    [key: string]: boolean;
  }>({});

  const openViewDrawer = (id: string) => {
    setDrawerViewStates((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };

  const closeViewDrawer = (id: string) => {
    setDrawerViewStates((prevState) => ({
      ...prevState,
      [id]: false,
    }));
  };

  const [modalDeclineStates, setModalDeclineStates] = useState<{
    [key: string]: boolean;
  }>({});

  const openDeclineModal = (id: string) => {
    setModalDeclineStates((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };

  const closeDeclineModal = (id: string) => {
    setModalDeclineStates((prevState) => ({
      ...prevState,
      [id]: false,
    }));
  };

  const [modalApproveStates, setModalApproveStates] = useState<{
    [key: string]: boolean;
  }>({});

  const openApproveModal = (id: string) => {
    dispatch(resetTransactionApprove());

    setModalApproveStates((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };

  const closeApproveModal = (id: string) => {
    dispatch(resetTransactionDecline());

    setModalApproveStates((prevState) => ({
      ...prevState,
      [id]: false,
    }));
  };

  return (
    <Box display="flex" alignItems="center" gap={4}>
      <PillButton
        background="#fff"
        border="1px solid #E0E3E6"
        color="gray.500"
        sx={{
          borderRadius: '44px',
          padding: '4px 24px',
          height: '32px',
          width: '75px',
        }}
        onClick={() => openViewDrawer(transaction?.id ?? '')}
      >
        View
      </PillButton>
      <PillButton
        background="#E54839"
        color="#fff"
        sx={{
          borderRadius: '44px',
          padding: '4px 24px',
          height: '32px',
          width: '75px',
        }}
        onClick={() => openDeclineModal(transaction?.id ?? '')}
      >
        Decline
      </PillButton>
      <PillButton
        background="#14CC52"
        color="#fff"
        sx={{
          borderRadius: '44px',
          padding: '4px 24px',
          height: '32px',
          width: '75px',
        }}
        onClick={() => openApproveModal(transaction?.id ?? '')}
      >
        Approve
      </PillButton>
      {/* <Menu placement="left-start">
        <MenuButton
          as={IconButton}
          aria-label="Approval Actions"
          icon={<EllipsisHorizontalIcon boxSize="32px" />}
          variant="unstyled"
        />
        <MenuList>
          <MenuItem
            background="#14CC52"
            color="#fff"
            borderRadius="4px"
            width="90px"
            height="28px"
            onClick={() => openApproveModal(transaction?.id ?? '')}
          >
            Approve
          </MenuItem>
          <MenuItem
            background="#E54839"
            color="#fff"
            borderRadius="4px"
            width="90px"
            height="28px"
            onClick={() => openDeclineModal(transaction?.id ?? '')}
          >
            Decline
          </MenuItem>
        </MenuList>
      </Menu> */}

      <CustomDrawer
        isClosable
        isOpen={drawerViewStates[transaction?.id ?? '']}
        onClose={() => closeViewDrawer(transaction?.id ?? '')}
        drawerHeader="Awaiting Approval Details"
      >
        <CustomDrawerHeader>Awaiting Approval Details</CustomDrawerHeader>

        <Box mt={2}>
          <TransactionDetails transaction={transaction} />
        </Box>

        <CustomDrawerFooter>
          <HStack gap={4} w="100%">
            <Button
              w="full"
              height="48px"
              color="#cc1440"
              background="#fae8ec"
              borderRadius="8px"
              fontWeight={400}
              onClick={() => openDeclineModal(transaction?.id ?? '')}
              _hover={{ backgroundColor: '#EFB6C4' }}
            >
              Decline
            </Button>
            <Button
              w="full"
              height="48px"
              color="#fff"
              background="#12ba4b"
              borderRadius="8px"
              fontWeight={400}
              onClick={() => openApproveModal(transaction?.id ?? '')}
              _hover={{ backgroundColor: '#0e913a' }}
            >
              Approve
            </Button>
          </HStack>
        </CustomDrawerFooter>
      </CustomDrawer>

      <CustomModal
        isOpen={modalDeclineStates[transaction?.id ?? '']}
        onClose={() => closeDeclineModal(transaction?.id ?? '')}
      >
        <DeclineTransactionMandate transaction={transaction} />
      </CustomModal>

      <CustomModal
        isOpen={modalApproveStates[transaction?.id ?? '']}
        onClose={() => closeApproveModal(transaction?.id ?? '')}
      >
        <ApproveTransactionMandate transaction={transaction} />
      </CustomModal>
    </Box>
  );
}
